import { useEffect, useState } from "react";
import type { CustomerItem } from "../mocks/customers";
import {
  getCustomers,
  rehydrateCustomers,
  setAllCustomers,
  subscribeCustomers,
} from "../store/customersStore";

export function useCustomers() {
  const [customers, setCustomers] = useState<CustomerItem[]>(() =>
    getCustomers()
  );

  useEffect(() => {
    rehydrateCustomers();

    const unsubscribe = subscribeCustomers(() => {
      setCustomers(getCustomers());
    });

    setCustomers(getCustomers());

    return () => {
      unsubscribe();
    };
  }, []);

  return {
    customers,
    setAllCustomers,
  };
}